module.exports = __webpack_public_path__ + "img/twitter-footer.0dfc80f2.svg";